<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div class="left-side-switch" onclick="sideChangeStatus();">
      <i class="fa" :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"></i>
    </div>-->
    <h6 class="tx-uppercase tx-10 tx-mont tx-spacing-1 mg-t-10 pd-x-10 tx-white-7">{{$t('product.条件筛选')}}</h6>
    <div class="mg-t-10 pd-x-10 mg-b-40">
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('product.商品名称')"
          class="form-control form-control-dark tx-14"
          @keyup.enter="filtrate()"
          v-model.trim="keyName"
        >
      </div>
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('product.SPU 编号')"
          class="form-control form-control-dark tx-14"
          @keyup.enter="filtrate()"
          v-model.trim="keySpu"
        >
      </div>
      <div class="mg-b-15 form-group">
        <input
          type="text"
          :placeholder="$t('product.SKU 编号')"
          class="form-control form-control-dark tx-14"
          @keyup.enter="filtrate()"
          v-model.trim="keySku"
        >
      </div>
      <div class="mg-b-10 form-group">
        <select class="form-control form-control-dark pd-y-0" v-model="keyStatus" @change="filtrate">
          <option value="">{{$t('product.选择状态')}}</option>
          <option v-for="(status, k) in $dict.newProStatus" :key="k" :value="k">{{$t(status)}}</option>
        </select>
      </div>
      <!--<div v-if="!(userInfo.productStyle == 9999)" class="mg-b-10 form-group">
        <select class="form-control form-control-dark pd-y-0" v-model="keySoldStatus" @change="filtrate">
          <option value="">$t('product.销售状态')</option>
          <option v-for="(status, k) in $dict.newProSoldStatus" :key="k" :value="k">{{status}}</option>
        </select>
      </div>-->
      <div class="form-group mg-b-10">
      		<div class="datepicker-group">
	          	<div class="input-group">
		            <span class="input-group-addon">
		              <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
		            </span>
		            <input v-model="keyDateFrom" data-id="datepicker-from" type="text" class="form-control-dark form-control fc-datepicker" :placeholder="$t('product.起始日期')">
		        </div>
	          	<div class="input-group">
		            <span class="input-group-addon">
		              <i class="icon ion-calendar tx-16 lh-0 op-6"></i>
		            </span>
		            <input v-model="keyDateTo" data-id="datepicker-to" type="text" class="form-control form-control-dark fc-datepicker" :placeholder="$t('product.截止日期')">
		        </div>
	        </div>
      </div>
      <button class="btn btn-primary btn-block tx-uppercase tx-11 tx-spacing-2 tx-medium" @click="filtrate">{{$t('product.筛 选')}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['status',"date_from","date_to","key_sku", "key_name", "key_scale", "key_status","key_spu","key_soldstatus","userInfo"],
  data(){
    return {
      keyDateFrom: "",
    	keyDateTo: "",
    	keyName: "",
      keySku: "",
      keySpu: "",
      keyStatus: '',
      keyScale: '',
      keySoldStatus:'',
    }
  },
  components: {
  },
  watch:{
    key_soldstatus: function() {
      this.keySoldStatus = this.key_soldstatus;
    },
    key_sku: function() {
      this.keySku = this.key_sku;
    },
    key_spu: function() {
      this.keySpu = this.key_spu;
    },
    key_name: function() {
      this.keyName = this.key_name;
    },
    key_scale: function(){
      this.keyScale = this.key_scale;
    },
    key_status: function(){
      this.keyStatus = this.key_status;
    },
    "date_from": function(){
      this.keyDateFrom = this.date_from;
    },
    "date_to": function(){
      this.keyDateTo = this.date_to;
    },
  },
  methods: {
  	filtrate() {
      this.$emit("filtrate", this.keyName, this.keySku, this.keyStatus,this.keySpu,this.keySoldStatus,this.keyDateFrom,
	    	this.keyDateTo);
    },
    sideChangeStatus() {
      //$t('product.边栏状态改变')
      this.$emit("changeStatus");
    },
    datepickerSelect() {
      let vm = this;
      $("[data-id=datepicker-from]").each(function() {
        $(this).datepicker({
          numberOfMonths: 1, //$t('product.显示月的数量')
          dateFormat: "yy-mm-dd", //$t('product.日期格式化')
          onClose: function(selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-to]"))
              .datepicker("option", "minDate", selectedDate);
          },
          onSelect: function(selectedDate) {
            	vm.keyDateFrom = selectedDate;
          }
        });
      });
      $("[data-id=datepicker-to]").each(function() {
        $(this).datepicker({
          numberOfMonths: 1, //$t('product.显示月的数量')
          dateFormat: "yy-mm-dd", //$t('product.日期格式化')
          onClose: function(selectedDate) {
            $(this)
              .parents(".datepicker-group")
              .find($("[data-id=datepicker-from]"))
              .datepicker("option", "maxDate", selectedDate);
          },
          onSelect: function(selectedDate) {
            vm.keyDateTo = selectedDate;
          }
        });
      });
    },
  },
  mounted() {
    this.datepickerSelect();
    $('.overflow-y-auto').perfectScrollbar();
    if(this.status){
      $('.overflow-y-auto').perfectScrollbar('destroy');
    }else{
      $('.overflow-y-auto').perfectScrollbar();
    }
  },
  updated() {
    this.datepickerSelect();
    $('.overflow-y-auto').perfectScrollbar();
    if(this.status){
      $('.overflow-y-auto').perfectScrollbar('destroy');
    }else{
      $('.overflow-y-auto').perfectScrollbar();
    }
  },
}
</script>
